module.exports = __webpack_public_path__ + "img/report-sample-11@3x.338b0841.png";